import { combineReducers } from 'redux'

import listReviewProduct from './listReviewProduct'
import hideReviewProduct from './hideReviewProduct'

export default combineReducers({
  listReviewProduct: listReviewProduct,
  hideReviewProduct: hideReviewProduct
})
